module.exports = __webpack_public_path__ + "static/media/Biomes_card_bg_01.39f8ba5b.jpg";